import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface StepProgressProps {
  currentStep: number; // 1 to 6
}

const steps = [
  { label: "Select Service", sub: "Choose your service" },
  { label: "Service Details", sub: "Tell us about your move" },
  { label: "Delivery Details", sub: "Destination information" },
  { label: "Bulky Items", sub: "Special items" },
  { label: "Pricing", sub: "Volume estimation" },
  { label: "Contact Info", sub: "Your details" },
  { label: "Review", sub: "Confirm Booking" },
];

const StepProgress: React.FC<StepProgressProps> = ({ currentStep }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        gap: 1,
        py: 3,
        overflowX: "auto",
      }}
    >
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isCompleted = currentStep > stepNumber;

        return (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* Circle */}
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                border: `2px solid ${
                  isActive || isCompleted
                    ? theme.palette.primary.main
                    : "#d1d5db"
                }`,
                background: isCompleted
                  ? theme.palette.primary.main
                  : isActive
                  ? "#fff"
                  : "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: isCompleted ? "#fff" : theme.palette.primary.main,
                fontSize: isCompleted ? 18 : 16,
                fontWeight: 700,
              }}
            >
              {isCompleted ? "✓" : stepNumber}
            </Box>

            {/* Labels */}
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                fontSize={13}
                fontWeight={700}
                color={isActive || isCompleted ? "#111" : "#aaa"}
              >
                {step.label}
              </Typography>
              <Typography
                fontSize={11}
                fontWeight={400}
                color={isActive || isCompleted ? "#555" : "#555"}
              >
                {step.sub}
              </Typography>
            </Box>

            {/* Divider Line */}
            {index !== steps.length - 1 && (
              <Box
                sx={{
                  width: 28,
                  height: 2,
                  background:
                    currentStep > stepNumber
                      ? theme.palette.primary.main
                      : "#d1d5db",
                  ml: 1,
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default StepProgress;
